import { createStore, compose, applyMiddleware } from 'redux'
import { RouterState, routerMiddleware } from 'connected-react-router'
import { History } from 'history'
import { createRootReducer } from '../reducers'
import thunk from 'redux-thunk';
import * as AuthModule from '../modules/auth'
import * as WordsModule from '../modules/words'



export interface AppState {
    router: RouterState,
    auth: AuthModule.State,
    words: WordsModule.State
}

export function configureStore(history : History) {

    let initialState : AppState | undefined = undefined;

    const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
    let store = createStore(createRootReducer(history), initialState, composeEnhancers(
        applyMiddleware(routerMiddleware(history)),
        applyMiddleware(thunk)
    ))

    AuthModule.configureStore(store.dispatch);

    return store;
}